export const FEDRAMP_WARNING_STORAGE_KEY = "fedrampWarningAcknowledged";
